import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { anchor, LogoMark } from "@/components/Navbar";

const HERO_IMG = "/images/hero.webp";

const reveal = (delay = 0) => ({
  initial: { y: 40, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  transition: { duration: 0.8, delay, ease: [0.2, 0.7, 0, 1] },
});

export default function Hero() {
  const navigate = useNavigate();

  return (
    <header className="relative pt-16 pb-24 md:pt-24 md:pb-32 overflow-hidden border-b border-[#0b2545]/10 bg-gradient-to-b from-[#faf8f5] via-[#f5efe4] to-[#faf8f5]">
      <div className="absolute inset-0 df-pattern" />
      <div className="absolute -left-48 top-1/2 -translate-y-1/2 pointer-events-none select-none" aria-hidden="true">
        <img src="/images/logo.png" alt="" className="w-[560px] h-[560px] rounded-full opacity-[0.06]" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 space-y-8">
          <motion.div {...reveal(0)} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 text-[#0b2545] text-xs font-mono-df uppercase tracking-widest">
            <span className="w-2 h-2 rounded-full bg-[#d4af37]" />
            <span>Ingrosso Prodotti Alimentari Halal · Rozzano (MI)</span>
          </motion.div>

          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl font-normal leading-[0.95] tracking-[-0.03em] text-[#0b2545] text-balance">
            <motion.span {...reveal(0.1)} className="block">Prodotti alimentari</motion.span>
            <motion.span {...reveal(0.22)} className="block"><span className="italic text-[#c59b27]">halal</span> all'ingrosso,</motion.span>
            <motion.span {...reveal(0.34)} className="block">con la cura di una volta.</motion.span>
          </h1>

          <motion.p {...reveal(0.46)} className="text-lg md:text-xl text-[#0b2545]/80 max-w-xl leading-relaxed">
            Dahmani Food rifornisce negozi etnici, ristoranti e rivenditori con specialità halal del Mediterraneo e del mondo: qualità selezionata, assortimento completo, consegne puntuali.
          </motion.p>

          <motion.div {...reveal(0.58)} className="flex flex-wrap items-center gap-4 pt-2">
            <button
              data-testid="hero-cta-contatta"
              onClick={() => anchor("/#contatti")}
              className="px-8 py-4 rounded-full bg-[#0b2545] text-white text-sm font-semibold tracking-wider uppercase hover:bg-[#d4af37] hover:text-[#06152d] transition-colors duration-300 shadow-lg shadow-[#0b2545]/15"
            >
              Richiedi Listino Ingrosso
            </button>
            <button
              data-testid="hero-cta-categorie"
              onClick={() => navigate("/prodotti")}
              className="px-7 py-4 rounded-full border border-[#0b2545]/25 text-[#0b2545] text-sm font-semibold tracking-wider uppercase hover:border-[#0b2545] transition-colors"
            >
              Sfoglia il Catalogo
            </button>
          </motion.div>

          <motion.div {...reveal(0.7)} className="pt-6 border-t border-[#0b2545]/10 grid grid-cols-3 gap-6 text-xs text-[#0b2545]/70">
            <div>
              <span className="block font-bold text-[#0b2545] uppercase tracking-wider">Catalogo B2B</span>
              <span>480+ Referenze Halal</span>
            </div>
            <div>
              <span className="block font-bold text-[#0b2545] uppercase tracking-wider">Halal</span>
              <span>Selezione Controllata</span>
            </div>
            <div>
              <span className="block font-bold text-[#0b2545] uppercase tracking-wider">Logistica</span>
              <span>Consegne Puntuali</span>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ clipPath: "inset(100% 0 0 0)" }}
          animate={{ clipPath: "inset(0% 0 0 0)" }}
          transition={{ duration: 1.1, delay: 0.2, ease: [0.7, 0, 0.2, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -top-6 -right-6 w-full h-full rounded-3xl border-2 border-[#d4af37]/40 pointer-events-none" aria-hidden="true" />
          <div className="relative w-full aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-2 border-[#d4af37]/30">
            <img
              src={HERO_IMG}
              alt="Prodotti alimentari halal premium: spezie, olio, datteri e couscous"
              className="absolute inset-0 w-full h-full object-cover df-drift"
              data-testid="hero-image"
            />
            <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-[#06152d]/90 via-[#06152d]/50 to-transparent text-white">
              <span className="text-[10px] uppercase font-mono-df tracking-widest text-[#d4af37] block">Qualità Selezionata</span>
              <p className="font-display text-lg text-white font-medium">Sapori autentici, dal produttore alla tua attività</p>
            </div>
          </div>
        </motion.div>
      </div>
    </header>
  );
}
